(function(angular) {
    'use strict';

    angular.module('um.commonDirectives').directive('filterEngineWrapper', filterEngineWrapperDirective);
    filterEngineWrapperDirective.$inject = ['$timeout', '$compile', 'filtersService', 'configService'];
    function filterEngineWrapperDirective($timeout, $compile, filtersService, configService) {
        return {
            restrict: 'A',
            scope: {
                filterReady: '=',
                filter: '='
            },
            link: function(scope, element, attr) {
                var renderFilterEngine = function renderFilterEngine() {
                    filtersService.getDimensionsAndMetrics()
                        .then(function(dimsAndMets) {
                            var _conf = {
                                metrics: _.keyBy(dimsAndMets.metrics, 'arrangeType'),
                                dimensions: _.keyBy(dimsAndMets.dimensions, 'arrangeType')
                            };

                            if (_.has(dimsAndMets, 'live')) {
                                _conf.live = _.get(dimsAndMets, 'live');
                            }

                            configService.init(_conf);

                            var tmp = {containers: [], dimensions: []};
                            if (scope.filter.hasOwnProperty('specification')) {
                                tmp.containers = scope.filter.specification.containers;
                                tmp.filters = scope.filter.specification.filters;
                            }

                            scope.filterEngine = {
                                allDimensions: _conf.dimensions,
                                allMetrics: _conf.metrics,
                                containers: tmp.containers,
                                filters: tmp.filters,
                                featureFlags: {},
                                showSimpleFilter: false,
                                validFilterPresent: {}
                            };

                            var template = '<div complex-filter id="complex-filter" class="filter-login-engine"'
                                + ' ng-show="filterReady" '
                                + ' all-dimensions="filterEngine.allDimensions" '
                                + ' all-metrics="filterEngine.allMetrics" '
                                + ' containers="filterEngine.containers" '
                                + ' filter-set="filterEngine.filters" '
                                + ' containers-enabled="true"'
                                + ' show-simple-filter="filterEngine.showSimpleFilter"'
                                + ' feature-flags="filterEngine.featureFlags"'
                                + ' valid-filter-present="filterEngine.validFilterPresent"'
                                + '></div>';

                            var ngElem = angular.element(template);
                            $compile(ngElem)(scope);
                            scope.filterReady = true;
                            element.empty().append(ngElem);
                        });
                };

                var accountId = filtersService.getSelectedAccountId();
                if (accountId && accountId !== '0') {
                    // ugly solution, but works for now
                    $timeout(function() {
                        renderFilterEngine();
                    });
                }

                scope.$watch(function() {
                    return filtersService.getSelectedAccountId();
                }, function(newId, oldId) {
                    if (newId && newId !== oldId) {
                        renderFilterEngine();
                    }
                });
            }
        };
    }
})(window.angular);
